export const GET_MERCHANDISING_CAMPAIGNS_DATA = 'GET_MERCHANDISING_CAMPAIGNS_DATA'
export const SET_MERCHANDISING_CAMPAIGNS_DATA = 'SET_MERCHANDISING_CAMPAIGNS_DATA'
export const SET_MERCHANDISING_CAMPAIGNS_ERROR = 'SET_MERCHANDISING_CAMPAIGNS_ERROR'
export const SET_MERCHANDISING_CAMPAIGNS_PROCESSING = 'SET_MERCHANDISING_CAMPAIGNS_PROCESSING'
export const CREATE_MERCHANDISING_CAMPAIGN = 'CREATE_MERCHANDISING_CAMPAIGN'
export const CREATE_MERCHANDISING_CAMPAIGN_SUCCESS = 'CREATE_MERCHANDISING_CAMPAIGN_SUCCESS'
export const CREATE_MERCHANDISING_CAMPAIGN_FAILURE = 'CREATE_MERCHANDISING_CAMPAIGN_FAILURE'
export const UPDATE_MERCHANDISING_CAMPAIGN = 'UPDATE_MERCHANDISING_CAMPAIGN'
export const UPDATE_MERCHANDISING_CAMPAIGN_SUCCESS = 'UPDATE_MERCHANDISING_CAMPAIGN_SUCCESS'
export const UPDATE_MERCHANDISING_CAMPAIGN_FAILURE = 'UPDATE_MERCHANDISING_CAMPAIGN_FAILURE'
export const DELETE_MERCHANDISING_CAMPAIGN = 'DELETE_MERCHANDISING_CAMPAIGN'
export const DELETE_MERCHANDISING_CAMPAIGN_SUCCESS = 'DELETE_MERCHANDISING_CAMPAIGN_SUCCESS'
export const DELETE_MERCHANDISING_CAMPAIGN_FAILURE = 'DELETE_MERCHANDISING_CAMPAIGN_FAILURE'
export const SET_CREATING_CAMPAIGN = 'SET_CREATING_CAMPAIGN'
export const CREATE_CAMPAIGN_CONTENT = 'CREATE_CAMPAIGN_CONTENT'
export const CREATE_CAMPAIGN_CONTENT_SUCCESS = 'CREATE_CAMPAIGN_CONTENT_SUCCESS'
export const CREATE_CAMPAIGN_CONTENT_FAILURE = 'CREATE_CAMPAIGN_CONTENT_FAILURE'
export const UPDATE_CAMPAIGN_CONTENT = 'UPDATE_CAMPAIGN_CONTENT'
export const UPDATE_CAMPAIGN_CONTENT_SUCCESS = 'UPDATE_CAMPAIGN_CONTENT_SUCCESS'
export const UPDATE_CAMPAIGN_CONTENT_FAILURE = 'UPDATE_CAMPAIGN_CONTENT_FAILURE'
export const DOWNLOAD_MERCHANDISING_CAMPAIGNS = 'DOWNLOAD_MERCHANDISING_CAMPAIGNS'
export const DOWNLOAD_MERCHANDISING_CAMPAIGNS_ERROR = 'DOWNLOAD_MERCHANDISING_CAMPAIGNS_ERROR'
export const GET_HAS_PREVIEW_MEDIA = 'GET_HAS_PREVIEW_MEDIA'
export const SET_HAS_PREVIEW_MEDIA = 'SET_HAS_PREVIEW_MEDIA'
export const GET_ONBOARD_CHOICES = 'GET_ONBOARD_CHOICES'
export const SET_ONBOARD_CHOICES = 'SET_ONBOARD_CHOICES'
export const CREATE_MERCHANDISING_CAMPAIGN_WITH_CONTENT =
  'CREATE_MERCHANDISING_CAMPAIGN_WITH_CONTENT'
export const CREATE_MERCHANDISING_CAMPAIGN_WITH_CONTENT_SUCCESS =
  'CREATE_MERCHANDISING_CAMPAIGN_WITH_CONTENT_SUCCESS'
export const CREATE_MERCHANDISING_CAMPAIGN_WITH_CONTENT_FAILURE =
  'CREATE_MERCHANDISING_CAMPAIGN_WITH_CONTENT_FAILURE'

export function getMerchandisingCampaignsData (options = {}) {
  const { page, perPage, slug, placement, viewMode, isActive, dateRange, placementLanguage } =
    options
  return {
    type: GET_MERCHANDISING_CAMPAIGNS_DATA,
    payload: {
      page,
      perPage,
      slug,
      placement,
      viewMode,
      isActive,
      dateRange,
      placementLanguage,
    },
  }
}

export function downloadMerchandisingCampaigns (options = {}) {
  const { language, page, perPage, slug, placement, isActive, dateRange } = options
  return {
    type: DOWNLOAD_MERCHANDISING_CAMPAIGNS,
    payload: {
      language,
      page,
      perPage,
      slug,
      placement,
      isActive,
      dateRange,
    },
  }
}

export function createMerchandisingCampaign (data) {
  return {
    type: CREATE_MERCHANDISING_CAMPAIGN,
    payload: { data },
  }
}

export function createMerchandisingCampaignFailure (response) {
  return {
    type: CREATE_MERCHANDISING_CAMPAIGN_FAILURE,
    payload: response,
  }
}

export function createMerchandisingCampaignSuccess (response) {
  return {
    type: CREATE_MERCHANDISING_CAMPAIGN_SUCCESS,
    payload: response,
  }
}

export function updateMerchandisingCampaign (data) {
  return {
    type: UPDATE_MERCHANDISING_CAMPAIGN,
    payload: { data },
  }
}

export function updateMerchandisingCampaignFailure (response) {
  return {
    type: UPDATE_MERCHANDISING_CAMPAIGN_FAILURE,
    payload: response,
  }
}

export function updateMerchandisingCampaignSuccess (response) {
  return {
    type: UPDATE_MERCHANDISING_CAMPAIGN_SUCCESS,
    payload: response,
  }
}

export function deleteMerchandisingCampaign (data) {
  return {
    type: DELETE_MERCHANDISING_CAMPAIGN,
    payload: { data },
  }
}

export function deleteMerchandisingCampaignFailure (response) {
  return {
    type: DELETE_MERCHANDISING_CAMPAIGN_FAILURE,
    payload: response,
  }
}

export function deleteMerchandisingCampaignSuccess (response) {
  return {
    type: DELETE_MERCHANDISING_CAMPAIGN_SUCCESS,
    payload: response,
  }
}

export function setMerchandisingCampaignsData ({ data, page, perPage, totalCount }) {
  return {
    type: SET_MERCHANDISING_CAMPAIGNS_DATA,
    payload: {
      data,
      page,
      perPage,
      totalCount,
    },
  }
}

export function setMerchandisingCampaignsError ({ language, error }) {
  return {
    type: SET_MERCHANDISING_CAMPAIGNS_ERROR,
    payload: { language, error },
  }
}

export function downloadMerchandisingCampaignsError ({ language, error }) {
  return {
    type: DOWNLOAD_MERCHANDISING_CAMPAIGNS_ERROR,
    payload: { language, error },
  }
}

export function setCreatingCampaign (bool) {
  return {
    type: SET_CREATING_CAMPAIGN,
    payload: bool,
  }
}

export function createCampaignContent (campaignContent) {
  return {
    type: CREATE_CAMPAIGN_CONTENT,
    payload: campaignContent,
  }
}

export function createCampaignContentSuccess (contentItem) {
  return {
    type: CREATE_CAMPAIGN_CONTENT_SUCCESS,
    payload: contentItem,
  }
}

export function createCampaignContentFailure ({ error, campaignId }) {
  return {
    type: CREATE_CAMPAIGN_CONTENT_FAILURE,
    error,
    campaignId,
  }
}

export function updateCampaignContent (contentItemId, campaignContent) {
  return {
    type: UPDATE_CAMPAIGN_CONTENT,
    payload: campaignContent,
    id: contentItemId,
  }
}

export function updateCampaignContentSuccess (contentItem) {
  return {
    type: UPDATE_CAMPAIGN_CONTENT_SUCCESS,
    payload: contentItem,
  }
}

export function updateCampaignContentFailure ({ error, campaignId }) {
  return {
    type: UPDATE_CAMPAIGN_CONTENT_FAILURE,
    error,
    campaignId,
  }
}

export function getHasPreviewMedia (payload) {
  return {
    type: GET_HAS_PREVIEW_MEDIA,
    payload,
  }
}

export function setHasPreviewMedia (payload) {
  return {
    type: SET_HAS_PREVIEW_MEDIA,
    payload,
  }
}

export function getOnboardChoices () {
  return {
    type: GET_ONBOARD_CHOICES,
  }
}

export function setOnboardChoices (payload) {
  return {
    type: SET_ONBOARD_CHOICES,
    payload,
  }
}

export function createMerchandisingCampaignWithContent (data) {
  return {
    type: CREATE_MERCHANDISING_CAMPAIGN_WITH_CONTENT,
    payload: { data },
  }
}

export function createMerchandisingCampaignWithContentSuccess (response) {
  return {
    type: CREATE_MERCHANDISING_CAMPAIGN_WITH_CONTENT_SUCCESS,
    payload: response,
  }
}

export function createMerchandisingCampaignWithContentFailure (response) {
  return {
    type: CREATE_MERCHANDISING_CAMPAIGN_WITH_CONTENT_FAILURE,
    error: response.error,
    campaign: response.campaign,
  }
}
